import { some } from 'lodash-es';

export function newShipmentGuard({ customerAccounts }) {
  return some(customerAccounts, account => account.newOrder.enabled);
}
